// Parser del código de barras PDF417 del DNI argentino.
// Los campos vienen separados por "@". Hay 2 formatos vigentes:
//  - Nuevo (código en el FRENTE): array de 8-9 elementos.
//    [1]=apellido [2]=nombre [3]=sexo [4]=dni [6]=fecha_nac [7]=fecha_emision
//  - Anterior (código en el DORSO): array de 16-17 elementos.
//    [1]=dni [4]=apellido [5]=nombre [7]=fecha_nac [8]=sexo [9]=fecha_emision
// Si el string no matchea ninguno de los 2 formatos (mala luz, DNI gastado,
// documento extranjero), devuelve null — el llamador debe permitir carga manual.
export function parseDniPdf417(raw) {
  if (!raw) return null;
  const clean = raw.replace(/[^\x20-\x7E\u00C0-\u00FF@]/g, "");
  const parts = clean.split("@").map((p) => p.trim());

  if (parts.length >= 8 && parts.length <= 9) {
    const dni = (parts[4] || "").replace(/\D/g, "");
    if (dni.length >= 7 && dni.length <= 8) {
      return { dni, surname: parts[1] || "", name: parts[2] || "" };
    }
  }
  if (parts.length >= 16) {
    const dni = (parts[1] || "").replace(/\D/g, "");
    if (dni.length >= 7 && dni.length <= 8) {
      return { dni, surname: parts[4] || "", name: parts[5] || "" };
    }
  }
  return null;
}
